module.exports = __webpack_public_path__ + "static/media/comic_plate_3.c1ae2161.png";